<div class="admin-container">
  <div class="admin-header">
    <h2>System Administration</h2>
    <p class="subtitle">Manage notifications, router templates, and feature configurations</p>
  </div>

  <kendo-tabstrip (tabSelect)="onTabSelect($event)" [animate]="true">
    <!-- Router Management Tabs -->
    <kendo-tabstrip-tab [title]="'Router Templates'" [selected]="true">
      <ng-template kendoTabContent>
        <app-router-templates></app-router-templates>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'Feature Mappings'">
      <ng-template kendoTabContent>
        <app-feature-router-mapping></app-feature-router-mapping>
      </ng-template>
    </kendo-tabstrip-tab>

    <!-- Notification Management Tabs -->
    <kendo-tabstrip-tab [title]="'Email Templates'">
      <ng-template kendoTabContent>
        <app-email-templates></app-email-templates>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'Distribution Lists'">
      <ng-template kendoTabContent>
        <app-distribution-lists></app-distribution-lists>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'Notification Log'">
      <ng-template kendoTabContent>
        <app-notification-log></app-notification-log>
      </ng-template>
    </kendo-tabstrip-tab>

    <!-- Deployment Bulletin Tab -->
    <kendo-tabstrip-tab [title]="'Deployment Bulletin'">
      <ng-template kendoTabContent>
        <app-send-bulletin></app-send-bulletin>
      </ng-template>
    </kendo-tabstrip-tab>

    <!-- Process Template Management Tabs -->
    <kendo-tabstrip-tab [title]="'Process Templates'">
      <ng-template kendoTabContent>
        <app-process-templates></app-process-templates>
      </ng-template>
    </kendo-tabstrip-tab>

    <!-- Resource Assignments Tab -->
    <kendo-tabstrip-tab [title]="'Resource Assignments'">
      <ng-template kendoTabContent>
        <app-resource-assignments></app-resource-assignments>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
